module.exports = __webpack_public_path__ + "static/img/zhuanjia1.7469528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhuanjia1.jpg
// module id = qoZB
// module chunks = 1